<template>
	<v-layout row class="flex-end">
		<v-menu bottom left disabled>
			<v-btn icon slot="activator" class="grey--text">
				<v-icon>more_vert</v-icon>
			</v-btn>
			<!-- <v-list>
				<v-list-tile @click="postSilentDiscard">
					<v-list-tile-title>Silent Discard</v-list-tile-title>
				</v-list-tile>
				<v-list-tile @click="takeActionOnPost(acceptStatus, post.id.N)">
					<v-list-tile-title>Discard Post</v-list-tile-title>
				</v-list-tile>
			</v-list>-->
		</v-menu>
	</v-layout>
</template>

<script>
import * as utils from "@/utils.js";
const { POST_STATUS } = utils;

export default {
	name: "AnalyticsElActions",
	props: ["post", "isCommentDisabled", "isSharingDisabled"],
	methods: {
		// toggleComments(id) {
		// 	this.$store.dispatch("TOGGLE_POST_COMMENTS", {
		// 		id,
		// 		action: !this.isCommentDisabled
		// 	});
		// },
		// toggleSharing(id) {
		// 	this.$store.dispatch("TOGGLE_POST_SHARING", {
		// 		id,
		// 		action: !this.isSharingDisabled
		// 	});
		// }
		// isDownloadable(post) {
		// 	return (
		// 		post.type &&
		// 		["image", "gif", "video", "audio"].indexOf(post.type.S) !== -1
		// 	);
		// },
		// promptToDownloadFile(post) {
		// 	let link = document.createElement("a");
		// 	link.target = "_blank";
		// 	link.setAttribute("href", post[post.type.S].S);
		// 	link.setAttribute("download", true);
		// 	document.body.appendChild(link); // Required for FF
		// 	link.click(); // This will download the data file
		// },
		// takeActionOnPost(status, id) {
		// 	if (status == POST_STATUS.APPROVED) {
		// 		let to_send = {
		// 			postId: id
		// 		};
		// 		this.$store.dispatch("ACCEPT_DISCARD_POST", {
		// 			ref: this,
		// 			data: to_send
		// 		});
		// 	}
		// },
		// postSilentDiscard() {
		// 	this.$bus.$emit("ON_SILENT_DISCARD");
		// },
	},
	computed: {
		acceptStatus() {
			const post = this.post;
			return post.authorIdStatus
				? post.authorIdStatus.S.split("_")[1]
				: null;
		}
	}
};
</script>

<style lang="scss" scoped>
.flex-end {
	display: flex;
	justify-content: flex-end;
}
</style>
